module.exports = __webpack_public_path__ + "static/media/dragonballz.0604b924.jpg";